import React, {useEffect, useState} from "react";
import {
    DayMarkers,
    GanttComponent,
    Inject,
    PdfExport,
    Sort,
    Toolbar,
    Filter,
    Selection,
    ExcelExport
} from "@syncfusion/ej2-react-gantt";
import "../../App.css"
import {useDispatch, useSelector} from "react-redux";
import {loadProjectsGantt} from "./projects/ganttProjectsAction";
import {ColumnDirective, ColumnsDirective} from "@syncfusion/ej2-react-gantt/src/gantt/columns-directive";
import {
    EventMarkerDirective,
    EventMarkersDirective
} from "@syncfusion/ej2-react-gantt/src/gantt/eventmarkers-directive";
import {PdfColor} from '@syncfusion/ej2-pdf-export';
import Tooltip from "./Tooltip";
import {loadProjectGantt} from "./project/ganttProjectAction";
import styled from "styled-components";
import RightLabel from "./RightLabel";
import Loader from "../progress-bar/Loader";

const Gantt = ({projectId, filteredProjects}) => {

    const dispatch = useDispatch()
    const {isLoading, projects} = useSelector(state => state.ganttProjects)
    const project = useSelector(state => state.ganttProject)
    const [data, setData] = useState([])
    let ganttInst = GanttComponent || null

    const projectFields = {
        id: 'id',
        name: 'name',
        startDate: 'startDate',
        endDate: "endDate",
        duration: 'duration',
        progress: 'advancement',
        pilot: 'pilot',
        axisName: 'axisName',
        child: 'actions',
    }
    useEffect(() => {
        if (projectId) {
            dispatch(loadProjectGantt(projectId))
        } else {
            dispatch(loadProjectsGantt())
        }
    }, [dispatch, projectId])

    useEffect(() => {
        if (projectId) {
            if (project) {
                setData([project])
            }
        } else {
            if(filteredProjects){
                setData(filteredProjects)
            }
        }
        return () => {
            setData([])
        }
    }, [project, projectId, projects, setData,filteredProjects])

    const queryTaskbarInfo = (args) => {

        if(args.data.advancement < 100){

            if(args.data.advancement > 0){
                args.progressBarBgColor = "#ffd980";
                args.taskbarBorderColor = "#ffd980";
                args.taskbarBgColor = "#ffd980";
            }

            if(args.data.advancement === 0){
                args.progressBarBgColor = "#E9405BFF";
                args.taskbarBorderColor = "#E9405BFF";
                args.taskbarBgColor = "#E9405BFF";
            }
        }

        else{
            args.progressBarBgColor = "lightgreen";
            args.taskbarBorderColor = "lightgreen";
            args.taskbarBgColor = "lightgreen";
        }
    }

    const tooltipTemplate = (args) => {
        const {parentItem, ganttProperties: {taskName, endDate, startDate, progress}} = args
        const formattedEndDate = endDate.toLocaleDateString("fr")
        const formattedStartDate = startDate.toLocaleDateString("fr")
        return (
            <Tooltip
                name={taskName}
                endDate={formattedEndDate}
                startDate={formattedStartDate}
                actionProgress={progress}
                isProject={parentItem === null}
            />
        );
    }

    const timelineSettings = {
        timelineUnitSize: 80,
        timelineViewMode: 'Month',
        weekStartDay: 1,
    };

    const customizeCell = (args) => {
        if (args.data.hasChildRecords) {
            args.cell.style.backgroundColor = "var(--color-blue-03)";
        }
    }
    const eventMarkerDay = new Date()

    const templateRight = (args) => {
        const pilot = args?.taskData.pilot
        return <RightLabel pilot={pilot}/>
    }
    if (isLoading || project.isLoading) {
        return <Loader/>
    }

    const FilterOptions = {type: 'Excel'}
    const toolbarOptions = ['PdfExport', 'ZoomIn', 'ZoomOut', 'ZoomToFit']

    const toolbarClick = (args) => {
        if (args.item.text === 'Pdf export') {

            let exportProperties = {
                fileName: 'projets.pdf',
                enableFooter: false,
                pageSize: 'A3',
                exportType: 'CurrentViewData',
                includeHiddenColumn: true,
            }
            ganttInst.pdfExport(exportProperties);
        }
    }


    const pdfQueryTaskbarInfo = (args) => {
        if (args.data.parentItem === null) {
            args.taskbar.taskColor = new PdfColor(137, 189, 248)
            args.taskbar.progressColor = new PdfColor(51, 148, 246 )
        } else {
            args.taskbar.taskColor = new PdfColor(166, 172, 181)
            args.taskbar.progressColor = new PdfColor(121, 121, 124)
        }
        args.taskbarBorderColor = new PdfColor(255, 255, 255)

    }

    return (
        <Container>
            {projectId ?
                <Explanations>
                    Pour avoir un Gantt du plan d'actions complet, pensez à bien renseigner la date de début et la date
                    de fin de votre action. Pour compléter ces champs, rendez-vous sur la liste des actions et cliquez
                    sur le stylo bleu de modification de l'action.
                </Explanations>
                :
                <Explanations>
                    Les projets qui s'affichent sur le Gantt sont les projets ayant une date de début et une date de fin
                    renseignée. Pour compléter ces champs, rendez-vous sur la liste des projets, le stylo bleu de
                    modification du projet et cliquez sur le bouton "Je paramètre mon projet".
                </Explanations>
            }
            <GanttComponent
                dataSource={data}
                taskFields={projectFields}
                queryTaskbarInfo={queryTaskbarInfo}
                tooltipSettings={{taskbar: tooltipTemplate}}
                timelineSettings={timelineSettings}
                queryCellInfo={customizeCell}
                allowSorting={true}
                allowFiltering={true}
                collapseAllParentTasks={true}
                /* eslint-disable-next-line no-template-curly-in-string */
                labelSettings={{leftLabel: '${advancement} %',rightLabel: templateRight}}
                rowHeight={45}
                filterSettings={FilterOptions}
                toolbar={toolbarOptions}
                toolbarClick={toolbarClick}
                pdfQueryTaskbarInfo={pdfQueryTaskbarInfo}
                allowPdfExport={true}
                height={'600px'}
                taskMode={'Manual'}
                ref={gantt => ganttInst = gantt}
            >
                <ColumnsDirective>
                    <ColumnDirective field='name' headerText='Nom'/>
                </ColumnsDirective>
                <EventMarkersDirective>
                    <EventMarkerDirective cssClass={'e-custom-event-marker'} day={eventMarkerDay} label="Aujourd'hui">
                    </EventMarkerDirective>
                </EventMarkersDirective>
                <Inject services={[DayMarkers, Sort, PdfExport, ExcelExport, Toolbar, Filter, Selection]}/>
            </GanttComponent>
        </Container>
    )
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
const Explanations = styled.p`
  align-self: center;
  width: 80%;
  text-align: center;
`

export default Gantt